import moment from 'moment';
import { Calendar, RefreshCw } from 'lucide-react';
import { Card, CardContent, Typography, Box, Divider, useTheme, alpha } from '@mui/material';

interface ContractDatesCardProps {
    licenseStatus: string;
    inicio_licence: Date | string | null
    final_licence: Date | string | null
}

const ContractDatesCard = ({ inicio_licence, final_licence, licenseStatus }: ContractDatesCardProps) => {
    const theme = useTheme();

    return (
        <Card sx={{
            height: '100%',
            transition: 'transform 0.2s',
            '&:hover': {
                transform: 'translateY(-2px)'
            }
        }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Informações do Contrato
                </Typography>

                <Box sx={{ mt: 3 }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        mb: 3,
                        p: 2,
                        borderRadius: 1,
                        backgroundColor: alpha(theme.palette.primary.main, 0.05)
                    }}>
                        <Calendar size={24} color={theme.palette.primary.main} />
                        <Box sx={{ ml: 2 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Inicio do Contrato Atual
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                                {inicio_licence ? moment(inicio_licence).format("DD/MM/YYYY") : ""}
                            </Typography>
                        </Box>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        p: 2,
                        borderRadius: 1,
                        backgroundColor: alpha(theme.palette.secondary.main, 0.05)
                    }}>
                        <RefreshCw size={24} color={theme.palette.secondary.main} />
                        <Box sx={{ ml: 2 }}>
                            <Typography variant="subtitle2" color="text.secondary">
                                Última data de renovação
                            </Typography>
                            <Typography variant="body1" fontWeight={500}>
                                {final_licence ? moment(final_licence).format("DD/MM/YYYY") : ""}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {final_licence && (
                    <Box sx={{ mt: 3, p: 2, borderRadius: 1, backgroundColor: 'rgba(0,0,0,0.02)' }}>
                        {licenseStatus !== 'expired' &&
                            <Typography variant="body2" color="text.secondary">
                                A próxima renovação será em <strong>{moment(final_licence).diff(moment(), 'days')} dias</strong>.
                            </Typography>
                        }
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default ContractDatesCard;